

import { UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { APP_RETIREMENT_URLS, APP_URLS, COUNTRY_FRANCE_ID } from '../../const/AppConst';
import { IAdresseSearchFeature } from '../../context/model';
import MgpFormInput from '../../elements/MgpFormInput/MgpFormInput';
import MgpAddressFormAutoComplete from '../../elements/MgpAddressFormAutoComplete/MgpAddressFormAutoComplete';
import MgpFormSelect from '../../elements/MgpFormSelect/MgpFormSelect';
import { useFetchNomenclature } from '../../hooks/useFetchNomenclature';
import { useEffect } from 'react';
import useAppState from '../../context/AppContext';

type InfoAddressInputFormComponentProps = {
    register: UseFormRegister<any>;
    errors: any;
    setValue: UseFormSetValue<any>;
    watch: UseFormWatch<any>;
    globalSave: boolean;
    countryShow?: boolean;
    currentStep: string;
    hasLieudit?: boolean;
}

export type InfoAddressInputTemplateFormData = {
    address: string;
    postalCode: string;
    city: string;
    countryId: string;
    lieudit: string;
    additionalAddress : string;
    buildingName: string;
  }
  



export default function InfoAddressInputTemplate({register, setValue, errors, watch, globalSave, countryShow, currentStep, hasLieudit = true} : Readonly<InfoAddressInputFormComponentProps>) {
    const {
        state: { updatedProposition }
    } = useAppState();
    if(countryShow === undefined) {countryShow = true}
    const countryNomenclature = useFetchNomenclature("country", true);

    useEffect(() => {
        if(countryNomenclature && updatedProposition?.countryId&& globalSave !==false) {
          setValue("countryId", updatedProposition.countryId);
        }
        
      }, [countryNomenclature]);
  
    function onAddressSelect(data:IAdresseSearchFeature) {
        setValue("address", data.properties.name);
        setValue("postalCode", data.properties.postcode);
        setValue("city", data.properties.city);
        countryShow
        && setValue("countryId", COUNTRY_FRANCE_ID);
    
    }
    

    return (      
        <div> 
            <div className='form-row'>
                <div className="form-group mw-100">
                <MgpFormInput
                    label="Complément du nom"
                    labelFontWeight='regular'
                    type="text"
                    register={register}
                    id="additionalAddress"
                    maxLength={38}
                    errors={errors}
                />
                </div>   
            </div>

             <div className='form-row'>
                <div className="form-group mw-100">
                <MgpFormInput
                    label="Résidence et bâtiment"
                    labelFontWeight='regular'
                    type="text"
                    register={register}
                    id="buildingName"
                    maxLength={38}
                    errors={errors}
                />
                </div>   
            </div>


            <div className='form-row'>
                <div className="form-group mw-100 autocomplete">         
                    <MgpAddressFormAutoComplete 
                        label="Numéro et libellé de la voie"  
                        type="text"
                        register={register}
                        id="address"
                        maxLength={38}
                        labelFontWeight='regular'
                        errors={errors} onDataSelect={(data) => {onAddressSelect(data)}} 
                        required={true}
                    />
                </div> 
            </div>     

            {hasLieudit &&
            <div className='form-row'>
                <div className="form-group mw-100">
                    <MgpFormInput 
                    label="Lieu-dit, Hameau, Commune, BP"
                    labelFontWeight='regular'
                    id="lieudit"
                    maxLength={38}
                    register={register}
                    errors={errors}
                    />
                </div>   
            </div>
            }
    
            <div className='form-row'>
                <div className="form-group mw-100">
                    <MgpFormInput
                            label="Code postal"
                            id="postalCode"
                            labelFontWeight='regular'
                            register={register} 
                            errors={errors}
                            required={true}
                            value={watch('postalCode')}
                    />
                </div>
            </div>
          
            <div className='form-row'>
                <div className="form-group mw-100">
                    <MgpFormInput
                        label="Ville"
                        id="city"
                        labelFontWeight='regular'
                        register={register} 
                        errors={errors}
                        required={true}
                        value={watch('city')}
                    />
                </div>
            </div>
          {countryShow &&
            <div className='form-row'>
                <div className="form-group mw-100">
                    <MgpFormSelect 
                        id="countryId" 
                        data={countryNomenclature.options} 
                        label="Pays" 
                        labelFontWeight='regular' 
                        register={register} 
                        errors={errors} 
                        required={true}/>
                </div>
            </div>    
            } 
            {(currentStep === APP_URLS.infoOldContractPage || currentStep === APP_RETIREMENT_URLS.infoOldContractPage) &&
            <div className="form-group mw-100 mt-sm">
                <p className='bg-menthe blanc p-xs flex va-center jc-start' style={{gap: "10px", flexWrap: "unset"}}>
                <i className='icon-info blanc '></i>
                <span style={{lineHeight: 1.5}}>
                    Merci de vérifier attentivement l'adresse postale de votre ancienne mutuelle.
                    Une adresse incorrecte ou incomplète pourrait retarder ou empêcher la résiliation de votre contrat.
                </span>
                </p>
            </div>  
            }
      </div>      
      
  )
}
